module.exports = __webpack_public_path__ + "static/media/execute_scheduledExam.6eb76baa.png";